var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-work-order-history',{staticClass:"pt-work-order-history__withData"})}
var staticRenderFns = []

export { render, staticRenderFns }